import DonateItemSections from 'features/DonateItemPage'
import React from 'react'

const DonateItem = () => {
  return (
    <DonateItemSections />
  )
}

export default DonateItem